import { Row } from '../../../../components/Basic/Blocks';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { Text } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import { IP_NUMBER_MAP } from '../../../../constans';
import { WIDTH_POSTING } from '../index';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';


const IpStockLine = ({ product = {}, ...props }) => {
  return (
    <>
      <TableLine>
        <TableCell width={WIDTH_POSTING[0]}>{product.artnumber_1c}</TableCell>
        <TableCell width={WIDTH_POSTING[0]}>{product.skus?.join(', ')}</TableCell>
        <TableCell width={WIDTH_POSTING[1]}>{product.name}</TableCell>
        <TableCell width={WIDTH_POSTING[13]} center={true}>
          <Text fontWeight={'600'} fontSize={'16px'}>
            {product.quantity}
          </Text>
        </TableCell>
        <TableCell width={WIDTH_POSTING[13]} center={true}>
          <Text fontWeight={'600'} fontSize={'16px'}>
            {product.reserved || 0}
          </Text>
        </TableCell>
        <TableCell width={WIDTH_POSTING[13]} center={true}>
          <Text
            fontWeight={'600'}
            fontSize={'16px'}
            style={
              product.available > 0
                ? { color: 'rgb(13 161 15)' }
                : product.available === 0
                  ? { color: '#909ca8' }
                  : { color: '#d02529' }
            }
          >
            {product.available}
          </Text>
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          {IP_NUMBER_MAP[product.ip_id]}
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          <ProviderList selectProviderId={product.provider_id} disabled={true} />
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          {product.price_avg} / {product.price_nds_avg}
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          {product.nds}
        </TableCell>
        <TableCell width={WIDTH_POSTING[4]} center={true}>
          <BarcodesBlock
            barcodes={product.barcodes}
            disabled
          // onAdd={(b) => onChange('barcode', b, 'add')}
          // onRemove={(b) => onChange('barcode', b, 'pull')}
          />
        </TableCell>

        <TableCell width={WIDTH_POSTING[14]} center={true}>
          {product.gtd?.map((item) => (
            <Row key={item.value}>{`${item.value} - ${item.quantity}шт  (${item.country})`}</Row>
          ))}
        </TableCell>

      </TableLine>
    </>
  );
};

export default IpStockLine;
